import type { PaymentMethodFormValues } from "./schemas/PaymentMethodSchema"
import { PaymentAccountTabLabel } from "./types"

import type { PaymentMethod } from "@/graphql/codegen/graphql"
import { PaymentAccountType } from "@/graphql/codegen/graphql"

type PaymentMethodDefaultValues = Omit<PaymentMethodFormValues, "accountType" | "method"> & {
  accountType: PaymentAccountType | null
  method: PaymentMethod | null
}

export const BANKING_FIELDS_DEFAULT_VALUES = {
  bankId: "",
  bankLocationId: "",
  swiftCode: "",
  iban: "",
  routingNumber: "",
  institutionNumber: "",
  accountNumber: "",
} as const

export const BANKING_FIELDS_KEYS = [
  "bankId",
  "bankLocationId",
  "swiftCode",
  "iban",
  "routingNumber",
  "institutionNumber",
  "accountNumber",
] as const

export const PAYMENT_METHOD_DEFAULT_VALUES: PaymentMethodDefaultValues = {
  companyId: "",
  locationId: "",
  accountType: null,
  method: null,
  ...BANKING_FIELDS_DEFAULT_VALUES,
}

export const tabLabelToAccountType = new Map([
  [PaymentAccountTabLabel.ACCOUNTS_PAYABLE, PaymentAccountType.Payable],
  [PaymentAccountTabLabel.ACCOUNTS_RECEIVABLE, PaymentAccountType.Receivable],
])
